import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoutes = ({ children, name }) => {
  const state = useSelector((state) => state.menus);
  const isAllowed = state?.data?.allowedMenus?.includes(name) || false;
  return isAllowed ? children : <Navigate replace to="/" />;
  // return (
  //   <Route
  //     {...restOfProps}
  //     render={(props) =>
  //       isAllowed ? <Component {...props} /> : <Navigate replace to="/" />
  //     }
  //   />
  // );
};

export default ProtectedRoutes;

ProtectedRoutes.propTypes = {
  // component: PropTypes.elementType,
  name: PropTypes.string,
  children: PropTypes.any
};
